import { useTheme } from '@mui/material/styles';
import React, { Fragment, memo } from 'react';
import { Box, Button, Paper, Tooltip, Typography } from '@mui/material';
import Styles from './MenuButton.module.less';
import { OpenInNew } from '@mui/icons-material';
import PropTypes from 'prop-types';
import { voidFunc } from '../../constants/PropTypeUtils';

const MenuButton = (props: MenuButton.propTypes) => {
  const { tooltip, icon, buttonText, disabled, onClick, testId } = props;

  const theme = useTheme();

  return (
    <Fragment>
      <Tooltip title={tooltip || ''}>
        <Box className={Styles.box}>
          <Paper elevation={2} className={Styles.paper}>
            <Button
              data-testid={testId}
              disabled={disabled}
              className={Styles.button}
              onClick={onClick}
            >
              {React.cloneElement(icon, {
                style: { fill: theme.palette.primary.main },
              })}
              <Typography className={Styles.text}>{buttonText}</Typography>
              <Box
                sx={{
                  my: 0.5,
                  flex: 1,
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <OpenInNew style={{ height: 16 }} />
              </Box>
            </Button>
          </Paper>
        </Box>
      </Tooltip>
    </Fragment>
  );
};

MenuButton.propTypes = {
  tooltip: PropTypes.string,
  buttonText: PropTypes.string,
  icon: PropTypes.node,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  testId: PropTypes.string,
};

MenuButton.defaultProps = {
  onClick: voidFunc,
};

export default memo(MenuButton);
